export default __webpack_public_path__ + "static/media/logo.4a50b488.svg";